import { Map } from 'immutable';

import * as t from '../../actions/MyFriendsActionTypes';

const initialState = Map({
  sendFriendsRequestWaiting: false,
  sendFriendsRequestSuccess: false,
  sendFriendsRequestMessage: { type: 'error', text: '' },

  loadFriendsWaiting: false,
  totalFriendsCount: 0,
  friends: [],

  removeFriendWaiting: false,
  removeFriendMessage: { type: 'error', text: '' },
  removeFriendSuccess: false,

  resolveFriendRequestWaiting: false,
  resolveFriendRequestSuccess: false,
  resolveFriendRequestMessage: {
    type: 'error',
    text: 'Magna fugiat in cillum excepteur fugiat culpa ullamco.',
  },

  friendRequestNotifications: [],
});

const reducer = function myFriendsReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_SEND_FRIEND_REQUEST_WAITING:
      return state.set('sendFriendsRequestWaiting', action.value);
    case t.SET_SEND_FRIEND_REQUEST_SUCCESS:
      return state.set('sendFriendsRequestSuccess', action.value);
    case t.SET_SEND_FRIEND_REQUEST_MESSAGE:
      return state.set('sendFriendsRequestMessage', action.message);
    case t.SET_LOAD_FRIENDS_WAITING:
      return state.set('loadFriendsWaiting', action.value);
    case t.SET_TOTAL_FRIENDS_COUNT:
      return state.set('totalFriendsCount', action.count);
    case t.SET_FRIENDS:
      return state.set('friends', state.get('friends').concat(action.friends));
    case t.SET_REMOVE_FRIEND_WAITING:
      return state.set('removeFriendWaiting', action.value);
    case t.SET_REMOVE_FRIEND_SUCCESS:
      return state.set('removeFriendSuccess', action.value);
    case t.SET_REMOVE_FRIEND_MESSAGE:
      return state.set('removeFriendMessage', action.message);
    case t.REMOVE_FRIEND_FROM_LOCAL_LIST:
      const friends = state.get('friends');
      const newFriends = [];
      friends.forEach((friend) => {
        if (friend.id !== action.friendId) {
          newFriends.push(friend);
        }
      });
      return state.set('friends', newFriends);
    case t.SET_RESOLVE_FRIEND_REQUEST_MESSAGE:
      return state.set('resolveFriendRequestMessage', action.message);
    case t.SET_RESOLVE_FRIEND_REQUEST_SUCCESS:
      return state.set('resolveFriendRequestSuccess', action.value);
    case t.SET_RESOLVE_FRIEND_REQUEST_WAITING:
      return state.set('resolveFriendRequestWaiting', action.value);
    case t.RESET_FRIENDS_OBJECT:
      return state.set('friends', []);
    case t.SET_FRIEND_REQUEST_NOTIFICATIONS:
      return state.set('friendRequestNotifications', action.notifications);
    default:
      return state;
  }
};

export default reducer;
